import "./App.css";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import DrBach from "./components/DrBach";
import About from "./components/About";
import NotFound from "./components/NotFound";
import Centers from "./components/Centers";
import Staff from "./components/Resources/Staff";
import FurtherInformation from "./components/Resources/FurtherInformation";
import Programs from "./components/Resources/Programs";
import Resources from "./components/Resources";
import ERprotocols from "./components/Resources/ERprotocols";
import ICUProtocols from "./components/Resources/ICUProtocols";
import OPProtocols from "./components/Resources/OPProtocols";
import AirStacking from "./components/Resources/AirStacking";
import PDFViewer from "./components/Viewer";
import SMA from "./components/SMA";

function App() {
  return (
    <Router>
      {" "}
      {/* Wrap everything in Router for routing functionality */}
      <div>
        <Navbar /> {/* Include the Navbar for navigation */}
        <Routes>
          {" "}
          {/* Set up the different routes */}
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Home />} /> {/* Home route */}
          <Route path="/ourcenters" element={<Centers />} /> {/* Home route */}
          <Route path="/ourcenters/staff" element={<Staff />} />
          <Route
            path="/ourcenters/furtherinformation"
            element={<FurtherInformation />}
          />
          <Route path="/ourcenters/programs" element={<Programs />} />
          <Route path="/drbach" element={<DrBach />} />
          <Route path="/resources" element={<Resources />} />;
          <Route path="/pdf-viewer/:file" element={<PDFViewer />} />;
          <Route path="/resources/er" element={<ERprotocols />} />;
          <Route path="/resources/icu" element={<ICUProtocols />} />;
          <Route path="/resources/op" element={<OPProtocols />} />;
          <Route path="/resources/as" element={<AirStacking />} />;
          <Route path="/resources/sma" element={<SMA />} />;
          <Route path="/about" element={<About />} /> {/* About route */}
        </Routes>
      </div>
      <div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
